import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/congratulations.css";
import useGameState from "../hooks/useGameState";
import useTranslation from "../hooks/useTranslation";

function Congratulations() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { resetGame } = useGameState();

  const handleFinish = () => {
    // Limpiar TODO el localStorage relacionado con el juego
    localStorage.removeItem('greenscape_language');
    localStorage.removeItem('greenscape_characters');
    localStorage.removeItem('greenscape_progress');
    localStorage.removeItem('greenscape_players_data');
    localStorage.removeItem('greenscape_risk_selections');
    localStorage.removeItem('greenscape_selected_dilemma_risks');
    localStorage.removeItem('greenscape_dilemma_proposals');
    localStorage.removeItem('greenscape_transformation_initiatives');
    
    // Llamar al resetGame del hook para asegurar que el estado también se limpia
    resetGame();
    
    console.log('✅ Todo el progreso del juego ha sido reiniciado');
    
    // Forzar recarga completa de la página para reiniciar todos los estados
    // Usamos window.location.href en lugar de navigate() para recargar completamente
    window.location.href = '/';
  };

  return (
    <div className="congratulations-container">
      {/* Contenido central */}
      <div className="congratulations-content">
        <div className="congratulations-header">
          <h1 className="game-titleC">{t('congratulations.gameTitle')}</h1>
          <h2 className="game-subtitleC">{t('congratulations.gameSubtitle')}</h2>
        </div>

        <div className="congratulations-box">
          <h2 className="congratulations-title">{t('congratulations.title')}</h2>
          
          <div className="congratulations-text">
            <p>
              {t('congratulations.paragraph1')}
            </p>
            
            <p>
              <strong>{t('congratulations.paragraph2')}</strong>
            </p>
            
            <p>
              {t('congratulations.paragraph3')}
            </p>
            
            <p>
              {t('congratulations.paragraph4')}
            </p>
            
            <p>
              {t('congratulations.paragraph5')}
            </p>
            
            <p>
              {t('congratulations.paragraph6')}
            </p>
            
            <p>
              {t('congratulations.paragraph7')}
            </p>
          </div>

          {/* Botón opcional para finalizar */}
          <button className="finish-button" onClick={handleFinish}>
            {t('congratulations.finishButton')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Congratulations;

